import { useEffect, useState } from "react"
import { createUseStyles } from 'react-jss'
import { useAppSelector } from "../redux/hooks"
import { useAppDispatch } from '../redux/hooks'
import { OpenShift, OpenShiftListFilter } from "../redux/types"
import FullScreenLoadingIndicator from "../components/FullScreenLoadingIndicator"
import Card from "../components/Card"
import { pageIndexChanged, filterChanged } from "../redux/slices/openShiftSlice"
import FilterComponent from "../components/OpenShift/OpenShiftListFilter"
import useDidUpdateEffect from "../hooks/useDidUpdateEffect"
import { useTranslation } from "react-i18next"
import useOpenShiftActions from "../hooks/useOpenShiftActions"
import OpenShiftList from "../components/OpenShift/OpenShiftList"
import OpenShiftRecipientModal from "../components/OpenShift/OpenShiftRecipientModal"

const OpenShifts = () => {
    const styles = useStyles()
    const { t } = useTranslation(['shifts', 'common']);
    const dispatch = useAppDispatch()

    const { getOpenShifts, getRecipientsForOpenShift } = useOpenShiftActions()
    const loading = useAppSelector(state => state.openShifts.loading)
    const shiftsOnPage = useAppSelector(state => state.openShifts.shiftsOnPage)
    const recipients = useAppSelector(state => state.openShifts.recipients)
    const totalShiftCount = useAppSelector(state => state.openShifts.totalShiftCount)
    const pageIndex = useAppSelector(state => state.openShifts.pageIndex)
    const pageSize = useAppSelector(state => state.openShifts.pageSize)
    const filter = useAppSelector(state => state.openShifts.filter)

    const [recipientModalVisible, setRecipientModalVisible] = useState<boolean>(false)

    useEffect(() => {
        if (shiftsOnPage.length === 0)
            getOpenShifts(filter?.includeDeleted ?? false, filter?.fromDate ?? undefined, filter?.toDate ?? undefined, pageIndex, pageSize)
    }, [])

    useDidUpdateEffect(() => {
        getOpenShifts(filter?.includeDeleted ?? false, filter?.fromDate ?? undefined, filter?.toDate ?? undefined, pageIndex, pageSize)
    }, [filter, pageIndex])

    const onPageChange = (pageIndex: number) => {
        dispatch(pageIndexChanged(pageIndex))
    }

    const handleFilterChange = (filter: OpenShiftListFilter) => {
        dispatch(filterChanged(filter))
    }

    const handleShowRecipientsClick = (openShift: OpenShift) => {
        getRecipientsForOpenShift(openShift.id)
        setRecipientModalVisible(true)    
    }

    return (
        <>
        <Card className={styles.card}>
            <h2>
            {t('title', {ns: 'openShifts'})}
            </h2>
        </Card>
        <Card>
            <div className={styles.filterContainer}>
                <FilterComponent
                    initialFilterValue={filter ?? undefined}
                    onFilterChange={handleFilterChange}
                />
            </div>
            {shiftsOnPage &&
            <OpenShiftList
                shiftsOnPage={shiftsOnPage}
                pageIndex={pageIndex}
                pageSize={pageSize}
                totalShiftCount={totalShiftCount}
                onShowRecipientsClick={handleShowRecipientsClick}
                onPageChange={onPageChange}
            />}
            <OpenShiftRecipientModal 
                visible={!loading && recipientModalVisible} 
                recipients={recipients}
                onCloseClick={() => setRecipientModalVisible(false) }
            />
            <FullScreenLoadingIndicator visible={loading} />
        </Card>
        </>
    )
}

export default OpenShifts

const useStyles = createUseStyles({
    card: {
        marginBottom: 20
    },
    filterContainer: {
        marginBottom: 20,
    },
    button: {
        alignSelf: 'flex-end'
    }
})
